import { SFCCBasket } from '../../../models/sfcc-basket';
import { makeCurrentBasketAction } from '../../../utilities/make-current-basket-action';
import { shopHttp } from '../../basket-api';

export const removeProduct = async (
  itemId: string,
  ensureBasketMethod: () => Promise<SFCCBasket>
): Promise<SFCCBasket> => {
  return await makeCurrentBasketAction(
    `items/${itemId}`,
    removeProductFromBasket,
    ensureBasketMethod
  );
};

const removeProductFromBasket = async (requestPath: string): Promise<SFCCBasket> => {
  const response = await shopHttp.delete<SFCCBasket>(requestPath);

  return response.data;
};
